import { EnumerationDisplayType } from 'customer-data-filters-ui/filterQueryFormat/DisplayTypes';
import DSFieldRecord from 'customer-data-filters-ui/filterQueryFormat/DSFieldRecord/DSFieldRecord';
import I18n from 'I18n';
import { STRING } from 'customer-data-objects/property/PropertyTypes';
import { EVENT_BASED_FIELD_KEYS } from 'customer-data-filters-ui/strategy/eventBasedFilters';
export const makeEventSubjectField = (filterFamily, __data, placeholder) => {
  return DSFieldRecord({
    displayType: EnumerationDisplayType,
    label: I18n.text(`newCustomerDataFilters.specialFields.${filterFamily}.${EVENT_BASED_FIELD_KEYS.EVENT_SUBJECT}`),
    name: EVENT_BASED_FIELD_KEYS.EVENT_SUBJECT,
    type: STRING,
    displayOrder: 1,
    referencedObjectType: filterFamily,
    placeholder
  });
};